// Angular imports
import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe, PercentPipe, CurrencyPipe } from '@angular/common';

// Import input cell type
import { InputCellType } from '../cell/input-cell/input-cell.component';

// Import types
import { Dimensions } from '../../types/types';

declare type CellType = InputCellType | 'currency';

@Pipe({
    name: 'formatCellValue',
    standalone: false
})
export class FormatCellValuePipe implements PipeTransform {
    constructor(private decimalPipe: DecimalPipe, private percentPipe: PercentPipe, private currencyPipe: CurrencyPipe) {};

    public transform(value: number | string | Dimensions, type: CellType): string {
        if (type === 'number')
            return this.decimalPipe.transform(<number>value, '1.0-3', 'nl');
        if (type === 'percent')
            return this.percentPipe.transform(<number>value, '1.0-3', 'nl');
        if (type === 'currency')
            return this.currencyPipe.transform(<number>value, 'EUR', '', null, 'nl');
        if (type === 'dimensions')
            return (value as Dimensions).width !== undefined ? `${(value as Dimensions).width} x ${(value as Dimensions).height}` : value.toString();
        if (type === 'text')
            return value ? value.toString() : '';
    }
}
